import clsx from 'clsx';
import React from 'react';
import {styled} from '@mui/material';
import {designSystemToken, Icon} from '@lightricks/react-design-system';
import styles from './AnimatedCaret.module.scss';

type IconSize = 'small' | 'medium' | 'large';

const StyledIcon = styled(Icon, {
  shouldForwardProp: (prop: string) => !['numericSize'].includes(prop),
})<{numericSize: number}>(({numericSize}) => ({
  width: `${numericSize}px !important`,
  height: `${numericSize}px !important`,
}));

type AnimatedCaretProps = {
  isOpen: boolean;
  appearance?: 'neutral' | 'brand';
  color?: string;
  size?: IconSize | number;
};

function AnimatedCaret({
  isOpen,
  appearance = 'neutral',
  color = designSystemToken('semantic.fg.secondary'),
  size = 'medium',
}: AnimatedCaretProps) {
  const isSizeNumeric = typeof size === 'number';
  const className = clsx(styles.caret, isOpen && styles.open);

  if (isSizeNumeric) {
    return (
      <StyledIcon
        className={className}
        name="Actions-Arrow-Down-Small"
        size="medium"
        appearance={appearance}
        color={color}
        numericSize={size}
      />
    );
  }

  return (
    <Icon
      className={className}
      name="Actions-Arrow-Down-Small"
      size={size}
      appearance={appearance}
      color={color}
    />
  );
}

export default AnimatedCaret;
